<span class="currency-container">
  <ng-content select="currency-start"></ng-content>
  @if (prefix) {
    {{ prefix }}
  }
  <ion-input

    #currencyInput
    [attr.aria-label]="ariaLabel"
    [attr.aria-labelledby]="ariaLabelledBy"
    [attr.aria-describedBy]="ariaDescribedBy"
    [id]="id"
    [name]="name"

    [placeholder]="placeholder"
    [required]="required"
    [disabled]="disabled"

    [color]="color"

    type="text"
    inputmode="decimal"

    [(ngModel)]="amount"
    #currency="ngModel"
    (ionBlur)="handleBlur();"
    (ionInput)="handleChange(currencyInput.value)"

    [ngClass]="{ 'ng-invalid ion-invalid': hasErrors }"
    >
  </ion-input>
  <ng-content select="currency-end"></ng-content>
</span>
